import React, { useState, useEffect, useRef } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Box, Typography } from '@mui/material'

const GlobalDropzone = ({ onFilesDropped, children }) => {
  const [dragging, setDragging] = useState(false)
  const dragCounter = useRef(0)

  useEffect(() => {
    const handleDragEnter = (e) => {
      e.preventDefault()
      e.stopPropagation()
      dragCounter.current++
      if (e.dataTransfer?.items?.length > 0) {
        setDragging(true)
      }
    }

    const handleDragLeave = (e) => {
      e.preventDefault()
      e.stopPropagation()
      dragCounter.current--
      if (dragCounter.current === 0) {
        setDragging(false)
      }
    }

    const handleDragOver = (e) => {
      e.preventDefault()
      e.stopPropagation()
    }

    const handleDrop = (e) => {
      e.preventDefault()
      e.stopPropagation()
      setDragging(false)
      dragCounter.current = 0

      if (e.dataTransfer?.files?.length > 0) {
        onFilesDropped(e.dataTransfer.files)
        e.dataTransfer.clearData()
      }
    }

    window.addEventListener('dragenter', handleDragEnter)
    window.addEventListener('dragleave', handleDragLeave)
    window.addEventListener('dragover', handleDragOver)
    window.addEventListener('drop', handleDrop)

    return () => {
      window.removeEventListener('dragenter', handleDragEnter)
      window.removeEventListener('dragleave', handleDragLeave)
      window.removeEventListener('dragover', handleDragOver)
      window.removeEventListener('drop', handleDrop)
    }
  }, [onFilesDropped])

  return (
    <Box position="relative">
      <AnimatePresence>
        {dragging && (
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.25, ease: 'easeOut' }}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              zIndex: 2000,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none',
              backgroundColor: 'rgba(0, 0, 0, 0.6)',
            }}
          >
            <Box
              px={4}
              py={2}
              borderRadius={2}
              bgcolor="rgba(0, 0, 0, 0.7)"
              boxShadow={3}
            >
              <Typography
                variant="h3"
                fontWeight="bold"
                sx={{
                  textAlign: 'center',
                  textShadow: '0px 4px 12px rgba(0,0,0,0.9)',
                  letterSpacing: 1,
                  color: '#fff !important',
                }}
              >
                Drop Files Anywhere
              </Typography>
            </Box>
          </motion.div>
        )}
      </AnimatePresence>
      {children}
    </Box>
  )
}

export default GlobalDropzone
